// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalWithTitle_wrapper__qwBty","title":"ModalWithTitle_title__24t8n","body":"ModalWithTitle_body__nQ-Ox"};